module.exports = __webpack_public_path__ + "img/logo_publichealth.6199e521.png";